import { gql } from "@apollo/client";

export const TOTAL_VISIT_LOGS = gql`
  query ($filters: FiltersExpression!) {
    countLogsAdmin(filters: $filters) {
      count
    }
  }
`;
